export default __webpack_public_path__ + "static/media/img2.87d75ca1.png";